import React, { useEffect, useState } from "react";
import Accordion from "./common/Accordion";
import InputFieldControl from "./common/InputFieldControl";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";

const EngagementDetails = ({
  customerDetails,
  editPermissions,
  refreshCustomerDetails = () => { },
}) => {

  const [ConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({

    lead_source: "",
    lead_type: "",
    sql: "0",
    // lead_score: "",
    lead_status: "",
    // action_taken: "",
    close_reason_details: "",
    close_reason: "",
    content_ready: "0",
  });

  useEffect(() => {
    if (customerDetails) {
      fetchFromData();
    }
  }, [customerDetails]);

  const fetchFromData = () => {
    setFormData({
      // name: customerDetails.name || "",
      email: customerDetails.email || "",
      // phone_number: customerDetails.phone_number || "",
      // company_name: customerDetails.company_name || "",
      // industry: customerDetails.industry || "",
      // created_date: customerDetails.created_date
      //   ? new Date(customerDetails.created_date)
      //   : null,
      // last_activity_date: customerDetails.last_activity_date
      //   ? new Date(customerDetails.last_activity_date)
      //   : null,
      // associated_products: customerDetails.associated_products || [],
      lead_source: customerDetails.lead_source || "",
      lead_type: customerDetails.lead_type || "",
      sql: customerDetails.sql || "0",
      // lead_score: parseInt(customerDetails.lead_score) || "0",
      lead_status: customerDetails.lead_status || "",
      // action_taken: customerDetails.action_taken || "",
      close_reason: customerDetails.close_reason || "",
      close_reason_details: customerDetails.close_reason_details || "",
      content_ready: customerDetails.content_ready || "0",
    });
  };

  const handleInputChange = (valueFor, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueFor]: value,
    }));
  };

  const onEditClick = () => {
    setIsEditing(true);
  };

  const handleContactInfoSave = async () => {
    setConfirmationModalOpen(false);
    setIsLoading(true);

    if (!handleValidation()) {
      setIsLoading(false);
      return;
    }

    const response = await storeLead(formData);

    if (response.success) {
      toast.success("Lead Updated successfully!");
      await refreshCustomerDetails();
    } else {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    }

    setIsEditing(false);
    setIsLoading(false);
  };

  const handleCancelEdit = () => {
    fetchFromData();
    setIsEditing(false);
  };

  const handleValidation = () => {
    setErrors({});

    const errors = {};
    let isValid = true;

    setErrors(errors);
    return isValid;
  };

  const ActionButton = () => {
    if (isLoading) {
      return (
        <button className="editprimary-btn editsecondry-btn" disabled>
          Loading...
        </button>
      );
    }

    return (
      <React.Fragment>
        <button
          className="editprimary-btn editsecondry-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (isEditing) {
              // onSaveClick();
              handleContactInfoSave();
            } else {
              onEditClick();
            }
          }}
        >
          {!isEditing && (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_501_8376)">
                  <path
                    d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                    stroke="#006EFA"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_501_8376">
                    <rect width="12" height="12" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {isEditing ? "Save" : "Edit"}
        </button>
        {isEditing && (
          <button
            className="editprimary-btn editsecondry-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelEdit();
            }}
          >
            {"Cancel"}
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <Accordion
      header="Engagement Details"
      targetID="EngagementDetails"
      actionButton={editPermissions && <ActionButton />}
      overrideOpenState={isEditing ? true : null}
    >
      <div className="form-customer-details">
        <div className="customer-info">

          <InputFieldControl
            fieldName="sql"
            label="SQL"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "Yes", id: "1" },
              { value: "No", id: "0" },
            ]}
            isLoading={isLoading}
            error={errors.sql}
          />
           <InputFieldControl
            fieldName="content_ready"
            label="Content Ready"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "Yes", id: "1" },
              { value: "No", id: "0" },
            ]}
            isLoading={isLoading}
            error={errors.content_ready}
          />
          <InputFieldControl
            fieldName="lead_status"
            label="Lead Status"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "No Response from Lead At All", id: "No Response from Lead At All" },
              { value: "Disqualified", id: "Disqualified" },
              { value: "Sales Disqualified", id: "Sales Disqualified" },
              { value: "Customer", id: "Customer" },
              { value: "Prospect", id: "Prospect" },
              { value: "Cold_Lead", id: "Cold_Lead" },
              { value: "Qualified Lead", id: "Qualified Lead" },
              { value: "Duplicate", id: "Duplicate" },
              { value: "Partnership Program", id: "Partnership Program" },
              { value: "Cold Lead", id: "Cold Lead" },
              { value: "Unindentified", id: "Unindentified" },
              { value: "Contact Made", id: "Contact Made" },
              { value: "Lost", id: "Lost" },
              { value: "Resurfaced Lead", id: "Resurfaced Lead" },
              { value: "Test Lead", id: "Test Lead" },
              { value: "Warm", id: "Warm" },
              { value: "On Hold", id: "On Hold" },
              { value: "Reseller", id: "Reseller" },
              { value: "Cold Partner Lead", id: "Cold Partner Lead" },
              { value: "Hot partner lead", id: "Hot partner lead" },
              { value: "Lead Stakeholder", id: "Lead Stakeholder" },
              { value: "Warm Partner Lead", id: "Warm Partner Lead" },
              { value: "Hot Lead", id: "Hot Lead" },
              { value: "Freely given consent from contact", id: "Freely given consent from contact" }
            ]}

            isLoading={isLoading}
            error={errors.lead_status}
          />
          <InputFieldControl
            fieldName="lead_type"
            label="Lead Type"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "SMB", id: "SMB" },
              { value: "Individual", id: "Individual" },
              { value: "Enterprise", id: "Enterprise" },
              { value: "Sanjh Contacts", id: "Sanjh Contacts" },
              { value: "Partner / Reseller / Affiliate / Referral", id: "Partner / Reseller / Affiliate / Referral" },
              { value: "Alie Contacts", id: "Alie Contacts" },
              { value: "Alie Newsletter Subscriptions", id: "Alie Newsletter Subscriptions" }
            ]}

            isLoading={isLoading}
            error={errors.lead_type}
          />

          <InputFieldControl
            fieldName="close_reason"
            label="Close Reason"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "Pricing High", id: "Pricing High" },
              { value: "Platform Difficult to Use", id: "Platform Difficult to Use" },
              { value: "Insufficient Support", id: "Insufficient Support" },
              { value: "Lead Dropped the Plan", id: "Lead Dropped the Plan" },
              { value: "Lead Stopped Responding", id: "Lead Stopped Responding" },
              { value: "Incorrect Email/ Phone No.", id: "Incorrect Email/ Phone No." },
              { value: "Features Missing", id: "Features Missing" },
              { value: "Duplicate", id: "Duplicate" },
              { value: "Junk / Not a Lead", id: "Junk / Not a Lead" },
              { value: "Other", id: "Other" },
              { value: "Unable to locate Lead", id: "Unable to locate Lead" },
              { value: "Phantom Lead", id: "Phantom Lead" },
              { value: "Muvi Test Lead", id: "Muvi Test Lead" },
              { value: "Lead doesn't have content", id: "Lead doesn't have content" },
              { value: "Lead Doesn't have budget", id: "Lead Doesn't have budget" },
              { value: "Lost to competition (Please mention competition in notes)", id: "Lost to competition (Please mention competition in notes)" },
              { value: "Others", id: "Others" },
              { value: "No Sign of Lead over Gmail / Outlook", id: "No Sign of Lead over Gmail / Outlook" }
            ]}


            isLoading={isLoading}
            error={errors.close_reason}
          />
          <InputFieldControl
            fieldName="close_reason_details"
            label="Close Reason Details"
            type={"textarea"}
            isEditing={isEditing} // Email is not editable
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.close_reason_details}
            // Make first letter uppercase
            defaultValue={
              customerDetails.close_reason_details
                ? customerDetails.close_reason_details.charAt(0).toUpperCase() +
                customerDetails.close_reason_details.slice(1)
                : ""
            }
          />
          
         
          
        </div>
      </div>

    </Accordion>
  );
};

export default EngagementDetails;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/EngagementDetails.js